module.exports = __webpack_public_path__ + "static/media/peer_image2.07fe3382.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_image2.png
// module id = 2649
// module chunks = 0